var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m26.04,21.64l-0.88,1.9l-2.32,0c-1.85,0 -3.34,1.48 -3.34,3.31l0,8.49c0,1.83 1.49,3.31 3.34,3.31l14.45,0c1.84,0 3.33,-1.48 3.33,-3.31l0,-8.49c0,-1.83 -1.49,-3.31 -3.33,-3.31l-2.33,0l-0.88,-1.9c-0.18,-0.39 -0.57,-0.64 -1.01,-0.64l-6.02,0c-0.44,0 -0.83,0.25 -1.01,0.64zm0.19,3.55l1.18,-2.54l5.31,0l1.18,2.54l3.39,0c0.92,0 1.67,0.75 1.67,1.66l0,8.49c0,0.91 -0.75,1.65 -1.67,1.65l-14.45,0c-0.93,0 -1.67,-0.74 -1.67,-1.65l0,-8.49c0,-0.91 0.74,-1.66 1.67,-1.66l3.39,0z",
    fill: "#DCDCDC",
    fillRule: "evenodd",
    id: "svg_3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m25.61,30.93c0,2.43 2,4.41 4.45,4.41c2.46,0 4.45,-1.98 4.45,-4.41c0,-2.44 -1.99,-4.41 -4.45,-4.41c-2.45,0 -4.45,1.97 -4.45,4.41zm7.23,0c0,1.52 -1.24,2.75 -2.78,2.75c-1.53,0 -2.78,-1.23 -2.78,-2.75c0,-1.53 1.25,-2.76 2.78,-2.76c1.54,0 2.78,1.23 2.78,2.76z",
    fill: "#DCDCDC",
    fillRule: "evenodd",
    id: "svg_4",
    transform: "matrix(1 0 0 1 0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImage);
export default __webpack_public_path__ + "static/media/defaultImage.fbadbd2c648388f2b3b1bd44f08f0d98.svg";
export { ForwardRef as ReactComponent };